import fetch from 'cross-fetch';
import { ApiV1Base, ApiPrefix, getCookie, json, statusCheck } from 'util/icwUtility';
import { createMessageAttachments } from 'api';
import { saveAttachmentToSupplier } from 'api/Messages/index';
import { actLoginTimedOut } from './loginStateActions';

export const CONVERSATION_INIT = 'CONVERSATION_INIT';
export function actConversationInit() {
  return { type: CONVERSATION_INIT };
}

export const NEW_CONVERSATION_INIT = 'NEW_CONVERSATION_INIT';
export function actNewConversationInit(data) {
  return { type: NEW_CONVERSATION_INIT, data };
}

//
//  ******* Conversations GET *******
//

export const CHAT_CONVERSATION_LIST_FETCH_POLLING = 'CHAT_CONVERSATION_LIST_FETCH_POLLING';
function actConversationsFetchPolling(data) {
  return { type: CHAT_CONVERSATION_LIST_FETCH_POLLING, data };
}

export const CHAT_CONVERSATION_LIST_FINISH = 'CHAT_CONVERSATION_LIST_FINISH';
function actConversationsFetchFinish(data) {
  return { type: CHAT_CONVERSATION_LIST_FINISH, data };
}

export const CHAT_CONVERSATION_LIST_FETCH_FAIL = 'CHAT_CONVERSATION_LIST_FETCH_FAIL';
function actConversationsListFetchFail(data) {
  return { type: CHAT_CONVERSATION_LIST_FETCH_FAIL, data };
}

export const actConversationsListFetch = () => async (dispatch) => {
  dispatch(actConversationsFetchPolling());
  await fetch(`${ApiV1Base}${ApiPrefix}/supplierMessages/suppliers/history`, {
    headers: { Authorization: getCookie('token') },
  })
    .then(statusCheck)
    .then(json)
    .then((data) => dispatch(actConversationsFetchFinish(data)))
    .catch((err) => {
      if (err.status === 401) {
        dispatch(actLoginTimedOut());
      }

      dispatch(actConversationsListFetchFail(err === 'object' ? err.message : err));
    });
};

//
//  ******* Messages history GET *******
//

export const MESSAGE_LIST_FETCH_POLLING = 'MESSAGE_LIST_FETCH_POLLING';
function actMessagesListFetchPolling(data) {
  return { type: MESSAGE_LIST_FETCH_POLLING, data };
}

export const MESSAGE_LIST_FETCH_FINISH = 'MESSAGE_LIST_FETCH_FINISH';
function actMessagesListFetchFinish(data) {
  return { type: MESSAGE_LIST_FETCH_FINISH, data };
}

export const MESSAGE_LIST_FETCH_FAIL = 'MESSAGE_LIST_FETCH_FAIL';
function actMessagesListFetchFail(data) {
  return { type: MESSAGE_LIST_FETCH_FAIL, data };
}

export const actMessagesListFetch = (supplierId) => async (dispatch) => {
  dispatch(actMessagesListFetchPolling());
  await fetch(`${ApiV1Base}${ApiPrefix}/supplierMessages/suppliers/${supplierId}`, {
    headers: { Authorization: getCookie('token') },
  })
    .then(statusCheck)
    .then(json)
    .then((data) =>
      dispatch(
        actMessagesListFetchFinish({
          supplierId,
          messageList: data,
          selectedSupplierId: supplierId,
        })
      )
    )
    .catch((err) => {
      if (err.status === 401) {
        dispatch(actLoginTimedOut());
      }

      dispatch(actMessagesListFetchFail(err === 'object' ? err.message : err));
    });
};

//
//  ******* Upload File Message POST *******
//

export const UPLOAD_FILE_MESSAGE_BEGIN = 'UPLOAD_FILE_MESSAGE_BEGIN';
function actUploadFileMessageBegin() {
  return { type: UPLOAD_FILE_MESSAGE_BEGIN };
}

export const UPLOAD_FILE_MESSAGE_SUCCESS = 'UPLOAD_FILE_MESSAGE_SUCCESS';
function actUploadFileMessageSuccess(data) {
  return { type: UPLOAD_FILE_MESSAGE_SUCCESS, data };
}

export const UPLOAD_FILE_MESSAGE_FAIL = 'ADD_MESSAGE_FAIL';
function actUploadFileMessageFail(reason) {
  return { type: UPLOAD_FILE_MESSAGE_FAIL, reason };
}

export const actUploadFileMessage = (supplierMessages, message, files, supplierId) => {
  return (dispatch) => {
    const documentListId = files.map((f) => f.id);
    dispatch(actUploadFileMessageBegin());
    return createMessageAttachments(supplierId, documentListId)
      .then((res) => {
        if (res.errorObj) {
          dispatch(
            actUploadFileMessageFail(
              res.errorObj === 'object' ? res.errorObj.message : res.errorObj
            )
          );
          return;
        }
        // if (data && data.length) {
        const recentMessage = { ...message };
        recentMessage.documentList = files.map((f) => f.id);
        recentMessage.documents = files.map((f) => ({
          name: f.fileName.split(',')[1] || f.fileName,
          url: f.url,
        }));

        dispatch(actUploadFileMessageSuccess(recentMessage));
        // }
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actUploadFileMessageFail(err === 'object' ? err.message : err));
      });
    // ;
    // // form-data
    // const formData = new FormData();
    // formData.append("supplierMessages", JSON.stringify(supplierMessages));
    // for (let i = 0; i < files.length; i++) {
    //     formData.append("file", files[i], files[i].name);
    // }

    // return fetch(`${ApiPrefix}/supplierMessages/files/upload`, {
    //     method: "POST",
    //     headers: {
    //         Authorization: getCookie("token")
    //     },
    //     body: formData,
    // })
    //     .then(statusCheck)
    //     .then(json)
    //     .then(data => {
    //         if (data && data.length) {
    //             const recentMessage = { ...message };
    //             recentMessage.documentList = data.map(f => f.documentId);
    //             recentMessage.documents = data.map(f => ({ name: f.originalName, url: f.url }));

    //             dispatch(actUploadFileMessageSuccess(recentMessage));
    //         }
    //     })
    //     .catch(err => {
    //         if (err.status === 401) {
    //             dispatch(actLoginTimedOut());
    //         }

    //         dispatch(actUploadFileMessageFail(err === "object" ? err.message : err));
    //     });
  };
};

//
//  ******* Message POST *******
//

export const ADD_MESSAGE_BEGIN = 'ADD_MESSAGE_BEGIN';
function actAddMessageBegin(data) {
  return { type: ADD_MESSAGE_BEGIN, data };
}

export const ADD_MESSAGE_SUCCESS = 'ADD_MESSAGE_SUCCESS';
function actAddMessageSuccess(data) {
  return { type: ADD_MESSAGE_SUCCESS, data };
}

export const ADD_MESSAGE_FAIL = 'ADD_MESSAGE_FAIL';
function actAddMessageFail(data) {
  return { type: ADD_MESSAGE_FAIL, data };
}

export const actAddMessage = (supplierId, message, files) => async (dispatch) => {
  dispatch(actAddMessageBegin());
  await fetch(`${ApiV1Base}${ApiPrefix}/supplierMessages/suppliers/${supplierId}`, {
    method: 'POST',
    headers: {
      Authorization: getCookie('token'),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ message }),
  })
    .then(statusCheck)
    .then(json)
    .then((data) => {
      dispatch(actAddMessageSuccess(data));

      // upload files
      if (files && files.length && data) {
        const supplierMessages = { id: [data.id] };
        dispatch(actUploadFileMessage(supplierMessages, data, files, supplierId));
      }
    })
    .catch((err) => {
      if (err.status === 401) {
        dispatch(actLoginTimedOut());
      }

      dispatch(actAddMessageFail(err === 'object' ? err.message : err));
    });
};

//
//  ******* Messages User List GET *******
//

export const CHAT_MESSAGES_USER_LIST_FETCH_POLLING = 'CHAT_MESSAGES_USER_LIST_FETCH_POLLING';
function actChatMessagesUserListFetchPolling() {
  return { type: CHAT_MESSAGES_USER_LIST_FETCH_POLLING };
}

export const CHAT_MESSAGES_USER_LIST_FETCH_FINISH = 'CHAT_MESSAGES_USER_LIST_FETCH_FINISH';
function actChatMessagesUserListFetchFinish(data) {
  return { type: CHAT_MESSAGES_USER_LIST_FETCH_FINISH, data };
}

export const CHAT_MESSAGES_USER_LIST_FETCH_FAIL = 'CHAT_MESSAGES_USER_LIST_FETCH_FAIL';
function actChatMessagesUserListFetchFail(reason) {
  return { type: CHAT_MESSAGES_USER_LIST_FETCH_FAIL, reason };
}

export const actChatMessageUserListFetch = () => async (dispatch) => {
  dispatch(actChatMessagesUserListFetchPolling());
  await fetch(`${ApiV1Base}${ApiPrefix}/supplierMessages/suppliers`, {
    headers: { Authorization: getCookie('token') },
  })
    .then(statusCheck)
    .then(json)
    .then((data) => dispatch(actChatMessagesUserListFetchFinish(data)))
    .catch((err) => {
      if (err.status === 401) {
        dispatch(actLoginTimedOut());
      }

      dispatch(actChatMessagesUserListFetchFail(err === 'object' ? err.message : err));
    });
};

export const MESSAGE_CENTER_RESET = 'MESSAGE_CENTER_RESET';
export function actMessageCenterReset() {
  return { type: MESSAGE_CENTER_RESET };
}

/**
 * SAVE TO MESSAGE
 */

export function actSaveAttachmentToProfile(supplierId, params) {
  return async () => {
    const { documentListIds } = params;
    // dispatch(actManagerSupplierDocumentUpdateBegin());
    return saveAttachmentToSupplier(supplierId, documentListIds);
  };
}
